<template>
    <div id="app" :class="[$store.getters.isMobileKeyboardOpen ? 'scrollVertically' : '']">
        <router-view/>
    </div>
</template>

<script>
    //install youtube api
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";

    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    export default {
        data() {
            return {
                currentVH: 0,
                currentVW: 0
            }
        },
        computed: {
            runningQuery() {
                return this.$store.getters.isQueryRunning;
            },
            needToRunQuery() {
                return this.$store.getters.doesSearchQueryHaveChanges;
            }
        },
        watch: {
            runningQuery(current, previous) {
                if(current != previous && !current) {
                    if(this.needToRunQuery) {
                        this.$store.dispatch('runSearchQuery');
                    }
                }
            },
            needToRunQuery(now, then) {
                if(now != then && now) {
                    this.$store.dispatch('runSearchQuery');
                }
            }
        },
        created() {
            var appComponent = this;

            window.onYouTubePlayerAPIReady = function() {
                appComponent.setYoutubePlayerReady();
            }

            this.setVisualHeight();

            this.$store.dispatch('setDefaultsForAvailableFilters');
            this.$store.dispatch('veriryUserAuthenticated', window.localStorage.getItem('socAuthUser'));
            this.$store.dispatch('pullListOfProductSpecialists');
            this.$store.dispatch('getAppUrls');
            this.$store.dispatch('getDeliveryLocations');

            //l listen for resize event and update the sizing variables
            window.addEventListener('resize', function() {
                if(!appComponent.softKeyboradInduced()) {
                    appComponent.setVisualHeight();
                }

                appComponent.tallyResize();
            });

            // listen for message from autocheck iframe reporting size of autocheck document in pixles
            window.addEventListener('message', function(event) {
                if(typeof event.data === 'string') {
                    if(event.data.includes("-")) {
                        let autocheckDocHeight = event.data.split('-')[1];
                        appComponent.setAutocheckIframeHeight(autocheckDocHeight);
                    }
                }
            });
        },
        methods: {
            setYoutubePlayerReady() {
                this.$store.setYoutubePlayerReadyState(true);
            },
            softKeyboradInduced() {
                return this.$store.getters.isMobileKeyboardOpen;
            },
            setVisualHeight() {
                // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
                let vh = window.innerHeight * 0.01;
                let vw = window.innerWidth * 0.01;
                let vratio = window.innerHeight / window.innerWidth;
                let screenHeight = window.screen.availHeight * 0.01;
                
                // Then we set the value in the --vh custom property to the root of the document
                document.documentElement.style.setProperty('--vh', `${vh}px`);
                document.documentElement.style.setProperty('--vw', `${vw}px`);
                document.documentElement.style.setProperty('--vratio', `${vratio}`);
                document.documentElement.style.setProperty('--deviceHeight', `${screenHeight}`);

                this.toggleMobileView();
            },
            tallyResize() {
                this.$store.commit('increaseResizeCount');
            },
            toggleMobileView() {
                let mobileView = window.innerHeight > window.innerWidth;
                let orientation = window.innerWidth / window.innerHeight;
                let tabletRatio = mobileView ? orientation >= (17/24) : orientation <= (24/17);
                let pnsDiv = document.getElementById('app');

                if(tabletRatio) {
                    mobileView = true;

                    if(!pnsDiv.classList.contains('tabletstyle')) {
                        pnsDiv.classList.add('tabletstyle');
                    }
                }
                else {
                    pnsDiv.classList.remove('tabletstyle');
                }

                this.$store.commit('updateView', mobileView);
                this.$store.commit('updateTabletStyling', tabletRatio);
                this.$store.commit('updateOrientation', (orientation > 1 ? 'landscape' : 'portrait'));
                    
                if(mobileView) {
                    if(!pnsDiv.classList.contains('inmobile')) {
                        pnsDiv.classList.add('inmobile');
                    }
                }
                else {
                    pnsDiv.classList.remove('inmobile');
                }
            },
            setBackButtonLoading(backButtonUsed) {
                this.$store.commit('setBackButtonUsed', backButtonUsed);
            },
            setAutocheckIframeHeight(autocheckDocHeight) {
                this.$store.commit('setAutocheckDocHeight', autocheckDocHeight);
            }
        }
    }
</script>

<style>
    :root {
        --mccluskeyBlue: #036FBB;
        --mccluskeyGold: #B3842D;/*#D9A840*//*#AF873F;*/
    }

    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        height: calc(100 * var(--vh));
        width: calc(100 * var(--vw));
        overflow: hidden;
    }

    #app a {
        font-weight: bold;
        color: #2c3e50;
    }

    #app.scrollVertically {
        overflow-y: scroll;
    }

    #app a.router-link-exact-active {
        color: #42b983;
    }
</style>
